import type { Action, ActionAsset } from '~/types/actions'
import type { EndpointsRegistry, FetchClient } from '../types'
import { GatewayEndpoints } from '../endpoints/gateway-endpoints'
import type { PaginatedResult, PaginationParams } from '~/types/pagination'
import type { SuccessNoContent } from '~/types/common'
//import { mockGetAllActions, mockGetActionById, mockGetActionAssetsById } from './mocks/actions.mocks'

//const USE_MOCK_ACTIONS = false

export interface ActionService {
  getAllActions: (pagination: PaginationParams, categories: string[]) => Promise<PaginatedResult<Action>>
  getActionById: (actionId: number) => Promise<Action>
  getActionAssetsById: (actionId: number, pagination: PaginationParams) => Promise<PaginatedResult<ActionAsset>>
  cancelAction: (actionId: number) => Promise<SuccessNoContent>
  retryAction: (actionId: number) => Promise<SuccessNoContent>
  cancelActionAsset: (actionId: number, assetId: number) => Promise<SuccessNoContent>
  retryActionAsset: (actionId: number, assetId: number) => Promise<SuccessNoContent>
}

export const registerEndpoints = (client: FetchClient, registry: EndpointsRegistry): ActionService => {
  return {
    getActionById: async (actionId: number): Promise<Action> => {
      // if (USE_MOCK_ACTIONS) {
      //   return mockGetActionById(actionId)
      // }

      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.GET_ACTION_BY_ID, {
        params: {
          id: actionId
        }
      })
      return await client<Action>(url, { method, headers, body })
    },

    getAllActions: async (pagination: PaginationParams, categories: string[]): Promise<PaginatedResult<Action>> => {
      // if (USE_MOCK_ACTIONS) {
      //   return mockGetAllActions(pagination, categories)
      // }

      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.ACTIONS_GET_ALL, {
        queryParams: {
          current_page: pagination.current_page,
          per_page: pagination.per_page,
          action_categories: categories
        }
      })
      return await client<PaginatedResult<Action>>(url, { method, headers, body })
    },

    getActionAssetsById: async (
      actionId: number,
      pagination: PaginationParams
    ): Promise<PaginatedResult<ActionAsset>> => {
      // if (USE_MOCK_ACTIONS) {
      //   return mockGetActionAssetsById(actionId, pagination)
      // }

      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.GET_ACTION_ASSETS_BY_ID, {
        params: {
          id: actionId
        },
        queryParams: {
          current_page: pagination.current_page,
          per_page: pagination.per_page
        }
      })
      return await client<PaginatedResult<ActionAsset>>(url, { method, headers, body })
    },

    cancelAction: async (actionId: number): Promise<SuccessNoContent> => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.CANCEL_ACTION, {
        params: {
          actionId
        }
      })
      return await client<SuccessNoContent>(url, { method, headers, body })
    },

    retryAction: async (actionId: number): Promise<SuccessNoContent> => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.RETRY_ACTION, {
        params: {
          actionId
        }
      })
      return await client<SuccessNoContent>(url, { method, headers, body })
    },

    cancelActionAsset: async (actionId: number, assetId: number): Promise<SuccessNoContent> => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.CANCEL_ASSET_ACTION, {
        params: {
          actionId,
          assetId
        }
      })
      return await client<SuccessNoContent>(url, { method, headers, body })
    },

    retryActionAsset: async (actionId: number, assetId: number): Promise<SuccessNoContent> => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.RETRY_ASSET_ACTION, {
        params: {
          actionId,
          assetId
        }
      })
      return await client<SuccessNoContent>(url, { method, headers, body })
    }
  }
}
